
    import * as React from 'react';

    const RadioUnselected16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M8 14.875a6.875 6.875 0 100-13.75 6.875 6.875 0 000 13.75zm0-.75a6.125 6.125 0 110-12.25 6.125 6.125 0 010 12.25z" /></svg>
        </div>
      );
    };

    RadioUnselected16.displayName = 'RadioUnselected16';

    export default RadioUnselected16;
  